"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiKit = void 0;
const react_1 = __importDefault(require("react"));
const Chakra = __importStar(require("@chakra-ui/react"));
const ChakraIcons = __importStar(require("@chakra-ui/icons"));
const freeSolidSvg = __importStar(require("@fortawesome/free-solid-svg-icons"));
const freeBrandsSvg = __importStar(require("@fortawesome/free-brands-svg-icons"));
const freeRegularSvg = __importStar(require("@fortawesome/free-regular-svg-icons"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const UiKitBase_1 = require("./UiKitBase");
const UiKitIcons_1 = require("./UiKitIcons");
const UiKitFileDrop_1 = require("./UiKitFileDrop");
const UiKitHooks_1 = require("./UiKitHooks");
const UiKitIcon = (props) => {
    return (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { onClick: props.onClick, cursor: props.onClick ? 'pointer' : 'auto', icon: freeSolidSvg[props.fontAwesomeIconName], color: props.color ?? UiKitBase_1.UiKitBase.consistency.gray90 }));
};
exports.UiKit = {
    ...UiKitBase_1.UiKitBase,
    Chakra,
    Form: {
        ...UiKitBase_1.UiKitBase.Form,
        FileDrop: UiKitFileDrop_1.UiKitFileDrop,
    },
    Hook: UiKitHooks_1.Hook,
    Icon: UiKitIcon,
    Icons: {
        FontAwesomeIcon: react_fontawesome_1.FontAwesomeIcon,
        FontAwesome: {
            solid: freeSolidSvg,
            brands: freeBrandsSvg,
            regular: freeRegularSvg,
        },
        Chakra: ChakraIcons,
        RedAsterisk: UiKitBase_1.UiKitRedAsterisk,
        Status: UiKitBase_1.UiKitStatusIcon,
        SVG: UiKitIcons_1.UiKitIcons,
    },
};
